(function () {
  /* -------------------------------
     tawk.to bubble positioning
  --------------------------------*/
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_API.customStyle = {
    visibility: {
      desktop: {
        position: 'br',
        xOffset: 20,
        yOffset: 72
      },
      mobile: {
        position: 'br',
        xOffset: 20,
        yOffset: 72
      }
    }
  };

  /* ---------------------------------------------------
    Cart header currency symbol fix for empty cart
  ------------------------------------------------------*/
  if (!window.Shopify || !Shopify.formatMoney) return;

  const moneyFormat = window.Shopify.money_format;
  const targetId = "header-cart-total";

  function fixCurrency(el) {
    if (!el) return;

    const value = el.textContent.trim();
    if (value === "$0.00" || value === "$ 0.00") {
      el.textContent = "₹0.00";
    }
  }

  function observeCartTotal() {
    const el = document.getElementById(targetId);
    if (!el) return;

    fixCurrency(el);

    const observer = new MutationObserver(() => {
      fixCurrency(el);
    });

    observer.observe(el, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === "complete") {
    observeCartTotal();
  } else {
    window.addEventListener("load", observeCartTotal);
  }

  document.querySelectorAll('.template-cart .cart-section .btn').forEach((btn) => {
    if (btn.querySelector('.btn__text')) return;
    btn.childNodes.forEach((node) => {
      if (node.nodeType === 3 && node.textContent.trim()) {
        const span = document.createElement('span');
        span.className = 'btn__text';
        span.textContent = node.textContent;
        btn.replaceChild(span, node);
      }
    });
  });
})();
